/*
* 阔地教育科技有限公司版权所有（codyy.com/codyy.cn）.
* Copyright (c) 2019, Codyy and/or its affiliates. All rights reserved.
* @Date: 2020.01.01 12:30.
* @Author
* @Description  项目 接口请求函数
**/

import request from '@/utils/request'

/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 banner数据 - 查询方法.
 **/

export function bannerData (params) {
  return request({
    url: '/api/bannerlist',
    method: 'get',
    params
  })
}

/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 主体区域 数据 - 查询方法.
 **/

export function contentData (params) {
  return request({
    url: '',
    method: 'get',
    params
  })
}

export function typeListData(params){
  return request({
    url:'/api/SelNewsType',
    method:'get',
    params
  })
}

/**
 *@Description 企业资讯
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 品牌栏目 区域 数据 - 查询方法.
 **/

export function enterpriseData (params) {
  return request({
    url: '/api/enterpriselist',
    method: 'get',
    params
  })
}

/**
 *@Description 最新活动
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 品牌栏目 区域 数据 - 查询方法.
 **/

export function latestData (params) {
  return request({
    url: '/api/enterpriselist',
    method: 'get',
    params
  })
}

/**
 *@Description 时尚资讯
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 品牌栏目 区域 数据 - 查询方法.
 **/

export function fashionData (params) {
  return request({
    url: '/api/enterpriselist',
    method: 'get',
    params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 产品验证查询 结果 - 查询方法.
 **/

export function searchData (params) {
  return request({
    url: '/api/searchdata',
    method: 'get',
    params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 逛店模块 - 查找店铺 区域 结果 - 查询方法.
 **/
export function areaData (params) {
  return request({
    url: '/api/arealist',
    method: 'get',
    params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 逛店模块 - 查找店铺 结果 - 查询方法.
 **/
export function searchStore (params) {
  return request({
    url: '/api/shoplist',
    method: 'get',
    params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 门店展示图片 结果 - 查询方法.
 **/
export function shopImgData (params) {
  return request({
    url: '/api/shopphotodata',
    method: 'get',
    params
  })
}

/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 新品 模块 数据 - 查询方法.
 **/
export function newsData (params) {
  return request({
    url: '/api/warelist',
    method: 'get',
    params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 商品详情 数据 - 查询方法.
 **/
export function WareDetailData (params) {
  return request({
    url: '/api/waredetail',
    method: 'get',
    params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 招聘 模块 数据 - 查询方法.
 **/
export function recruitData (params) {
  return request({
    url: '/api/recruitlist',
    method: 'get',
    params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 招聘详情 模块 数据 - 查询方法.
 **/
export function recruitDetailData (params) {
  return request({
    url: '/api/recruitdetail',
    method: 'get',
    params
  })
}

/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 招聘详情 模块 数据 - 查询方法.
 **/
export function teamData (params) {
  return request({
    url: '/api/teamdata',
    method: 'get',
    params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 招聘详情 模块 数据 - 查询方法.
 **/
export function teamPhotoData (params) {
  return request({
    url: '/api/teamphotodata',
    method: 'get',
    params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 在线联系 模块 数据 提交 - 查询方法.
 **/
export function conactUp (params) {
  return request({
    url: '/api/savleave',
    method: 'post',
    data: params
  })
}
/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 文章详情 模块 数据 提交 - 查询方法.
 **/
export function articleDetail (params) {
  return request({
    url: '/api/selarticle',
    method: 'get',
    params
  })
}

/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 TVC 模块 视频播放列表 - 查询方法.
 **/
export function videoData (params) {
  return request({
    url: '',
    method: 'get',
    params
  })
}


/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 导航数据 - 查询方法.
 **/

export function navData (params) {
  return request({
    url: '',
    method: 'get',
    params
  })
}

/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 右侧浮动 导航数据 - 查询方法.
 **/

export function floatData (params) {
  return request({
    url: '/api/floatdata',
    method: 'get',
    params
  })
}

/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 底部数据查询方法.
 **/

export function footerData (params) {
  return request({
    url: '/api/footerdata',
    method: 'get',
    params
  })
}

